import type { IconSvgObject } from './types';

const DrawingModeIcon: IconSvgObject = [
  ["path", { d: "M16 9C16 5.13401 12.866 2 9 2C5.13401 2 2 5.13401 2 9C2 12.866 5.13401 16 9 16", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M22 20C22 21.1046 21.1046 22 20 22L11 22C9.89543 22 9 21.1046 9 20L9 11C9 9.89543 9.89543 9 11 9L20 9C21.1046 9 22 9.89543 22 11V20Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default DrawingModeIcon;
